'use client';

import { ErrorPid } from '@/shared/pid/components';

import HeaderDashboard from '../../../../shared/pid/components/DashboardOrMyTeam/HeaderDashboard';

export default function ErrorView({
  error,
  reset,
}: {
  error: (Error & { digest?: string }) | string;
  reset: () => void;
}) {
  return (
    <div>
      <div className="tw-w-full">
        <HeaderDashboard />
      </div>
      <div className="tw-w-full tw-h-[100vh]  tw-py-3.6 tw-px-4.8 tw-bg-neutral-light-200">
        <div className="tw-w-full tw-h-[70vh]">
          <ErrorPid error={error} reset={() => reset()} />
        </div>
      </div>
    </div>
  );
}
